export const isValidIndexSignature = (
  item: unknown
): item is string | number => {
  return (
    Boolean(item) && (typeof item === 'string' || typeof item === 'number')
  );
};
